export type RuntimeConfig = {
    clientId: string;
    selfServiceBaseUrl: string;
};

let runtimeConfig: RuntimeConfig | null = null;

function normalizeConfig(config: RuntimeConfig): RuntimeConfig {
    return {
        clientId: config.clientId,
        selfServiceBaseUrl: config.selfServiceBaseUrl.replace(/\/$/, ""),
    };
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
    const response = await fetch("/config.json", {cache: "no-store"});
    if (!response.ok) {
        throw new Error(`Failed to load runtime config: ${response.status}`);
    }
    const config = normalizeConfig(await response.json() as RuntimeConfig);
    runtimeConfig = config;
    return config;
}

export function setRuntimeConfig(config: RuntimeConfig): void {
    runtimeConfig = normalizeConfig(config);
}

export function getRuntimeConfig(): RuntimeConfig {
    if (!runtimeConfig) {
        throw new Error("Runtime config not loaded");
    }
    return runtimeConfig;
}
